import styles from './LearningLibraryCard.module.css';

const LearningLibraryCard = () => {
    return (
        <div className={styles.cardWrapper}>
            <h3 className={styles.title}>Learning Library</h3>
            <p className={styles.comingSoon}>Coming Soon!</p>
        </div>
    );
};

export default LearningLibraryCard;
